import api from "@/lib/api";

function crud(base) {
  return {
    list: (params) => api.get(base, { params }),
    create: (d) => api.post(base, d),
    update: (id, d) => api.put(`${base}/${id}`, d),
    remove: (id) => api.delete(`${base}/${id}`),
  };
}

// Admin CMS API (global-admin only)
export const cms = {
  dashboard: () => api.get("/cms/dashboard"),
  pages: {
    list: (params) => api.get("/cms/content-pages", { params }),
    get: (id) => api.get(`/cms/content-pages/${id}`),
    create: (data) => api.post("/cms/content-pages", data),
    update: (id, data) => api.put(`/cms/content-pages/${id}`, data),
    publish: (id) => api.post(`/cms/content-pages/${id}/publish`),
    unpublish: (id) => api.post(`/cms/content-pages/${id}/unpublish`),
    archive: (id) => api.post(`/cms/content-pages/${id}/archive`),
    remove: (id) => api.delete(`/cms/content-pages/${id}`),
    schemaPreview: (data) => api.post("/cms/schema-preview", data),
    previewBody: (data) => api.post("/cms/preview-body", data),
    extractFaqs: (id) => api.post(`/cms/content-pages/${id}/extract-faqs`),
  },
  clusters: crud("/cms/topic-clusters"),
  silos: crud("/cms/seo-silos"),
  seedSilos: () => api.post("/cms/seed-silos"),
  seedDepartmentPages: () => api.post("/cms/seed-department-pages"),
  seedAssets: () => api.post("/cms/assets/seed-screenshots"),
  aiAutofill: (id, overwrite = false) => api.post(`/cms/content-pages/${id}/ai-autofill?overwrite=${overwrite}`),
  ctas: crud("/cms/ctas"),
  proof: crud("/cms/proof-blocks"),
  links: crud("/cms/internal-links"),
  redirects: crud("/cms/redirects"),
  imports: {
    manual: (data) => api.post("/cms/imports/manual", data),
    preview: (data) => api.post("/cms/imports/bulk/preview", data),
    commit: (data) => api.post("/cms/imports/bulk/commit", data),
    koala: (data) => api.post("/cms/imports/koala", data),
    url: (data) => api.post("/cms/imports/url", data),
    list: () => api.get("/cms/imports"),
    reviewQueue: () => api.get("/cms/review-queue"),
  },
  performance: () => api.get("/cms/performance"),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.post("/cms/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  },
  assets: {
    list: (params) => api.get("/cms/assets", { params }),
    get: (id) => api.get(`/cms/assets/${id}`),
    create: (d) => api.post("/cms/assets", d),
    update: (id, d) => api.put(`/cms/assets/${id}`, d),
    approve: (id) => api.post(`/cms/assets/${id}/approve`),
    archive: (id) => api.post(`/cms/assets/${id}/archive`),
    remove: (id) => api.delete(`/cms/assets/${id}`),
    usage: (id) => api.get(`/cms/assets/${id}/usage`),
    suggest: (params) => api.get("/cms/assets/suggest", { params }),
    upload: (file, fields = {}) => {
      const fd = new FormData();
      fd.append("file", file);
      Object.entries(fields).forEach(([k, v]) => fd.append(k, v ?? ""));
      return api.post("/cms/assets/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    },
  },
};

// Public read API (no auth)
export const publicCms = {
  list: (params) => api.get("/public/resources", { params }),
  page: (path) => api.get("/public/resources/page", { params: { path } }),
};

export const VOCAB = {
  content_types: [
    "blog_article", "pillar_page", "industry_page", "department_page", "tool_page",
    "comparison_page", "calculator_page", "template_page", "checklist_page",
    "glossary_page", "trust_objection_page",
  ],
  statuses: ["draft", "published", "unpublished", "archived"],
  funnel_stages: ["TOFU", "MOFU", "BOFU"],
  aida_stages: ["Awareness", "Interest", "Desire", "Action"],
  schema_types: ["Auto", "Article", "FAQPage", "BreadcrumbList", "SoftwareApplication", "HowTo", "ItemList"],
  cta_types: ["primary", "secondary", "inline", "banner"],
  proof_block_types: [
    "ai_value_label", "sample_report", "evidence_quality_explainer", "decision_framework",
    "no_surveillance_trust", "before_after_workflow", "product_screenshot",
    "comparison_table", "checklist", "calculator_preview",
  ],
  internal_link_types: ["pillar", "related", "next_best", "cta", "breadcrumb"],
};

export const ASSET_TYPES = [
  "app_screenshot", "report_screenshot", "ai_value_label", "branded_diagram",
  "framework_graphic", "proof_block_image", "og_image", "koala_generated",
  "uploaded", "external_url",
];
export const ASSET_FEATURES = [
  "Dashboard", "Time Tracker", "Time Savings", "Costs & ROI", "Forecasting",
  "AI Tools", "Decisions", "Evidence Quality", "Reports", "Integrations", "Settings",
];
export const ASSET_STATUSES = ["draft", "approved", "needs_replace", "archived"];

export const CMS_NAV = [
  { to: "/admin/seo", label: "Dashboard", end: true },
  { to: "/admin/seo/pages", label: "Content Pages" },
  { to: "/admin/seo/imports", label: "Content Imports" },
  { to: "/admin/seo/assets", label: "Visual Assets" },
  { to: "/admin/seo/silos", label: "SEO Silos" },
  { to: "/admin/seo/clusters", label: "Topic Clusters" },
  { to: "/admin/seo/ctas", label: "CTA Library" },
  { to: "/admin/seo/proof-blocks", label: "Proof Blocks" },
  { to: "/admin/seo/internal-links", label: "Internal Links" },
  { to: "/admin/seo/redirects", label: "Redirects" },
  { to: "/admin/seo/performance", label: "Performance" },
];
